import React, { useEffect, useState } from "react";
import { SimpleInputFiled } from "../../components/ReactHooksFormFields/inputField";
import Logo from "../../assests/images/login-logo.png";
import {
  useChangePindCodeMutation,
  authApi,
} from "../../redux/service/authService";
import {
  getLoggedinUser,
  isPatient,
  isCaregiver,
  setLocalStorage,
} from "../../userStore";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import FullScreenLoader from "../../components/FullScreenLoader";

const CreatePin = () => {
  const [pinCode, setPinCode] = useState("");
  const [changePinCode, { isLoading, error }] = useChangePindCodeMutation();
  const user = getLoggedinUser();
  const navigate = useNavigate();
  const [getUserDetailsTrigger] =
    authApi.endpoints.getUserDetails.useLazyQuery();

  useEffect(() => {
    try {
      document.title = `ethizo`;
      if (window?.NUSA_closeVuiForm) {
        window?.NUSA_closeVuiForm();
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      confirm_pincode: pinCode,
      pincode: pinCode,
      token: user?.token,
    };
    const result = await changePinCode({ ...payload });

    if (result.error) {
      console.error("Failed to create pin", result.error);
    } else {
      if (result?.data?.code === 0) {
        toast.success("Pin created successfully");
        setLocalStorage("isLoggedIn", true);
        setLocalStorage("session", { ...user, pincode: pinCode });
        if (isCaregiver()) {
          navigate("/patients");
        } else {
          navigate("/dashboard");
        }

        toast.success("Login successful");
        // window.location.reload();
      } else {
        toast.error("Failed to create pin: " + result.data?.response?.msg);
      }
    }
  };

  return (
    <div className="block">
      <div className="login-bg h-screen flex items-center justify-center z-[100]">
        <div className="login-box rounded-3xl p-12 w-[650px]">
          {isLoading && <FullScreenLoader />}
          <form onSubmit={onSubmit}>
            <div className="flex justify-center">
              <div>
                <h3 className="text-lg mb-2 font-normal text-black-39">
                  Welcome to
                </h3>
                <img src={Logo} alt="" className="w-[237px]" />
                <p className="mt-2 text-right text-vColor font-light">V 2.0</p>
              </div>
            </div>
            <div className="flex spacing-y-4 content-center flex-col">
              <h4 className="text-3xl text-center text-black font-light mb-4">
                Please Create 4 Digits PIN
              </h4>
            </div>
            <div className="w-full float-center">
              <div className="self-center text-center  ml-16 mr-16">
                <SimpleInputFiled
                  name="pin"
                  type="password"
                  label="Enter 4 Digits PIN"
                  maxLength={4}
                  minLength={4}
                  className="block w-full appearance-none  focus:outline-none bg-transparent focus:ring-0 text-base font-light text-black-300 text-center font-bold text-[24px]"
                  onChange={(value) => {
                    const numericValue = value?.replace(/[^0-9]/g, "");
                    if (numericValue?.length <= 4) {
                      // Ensure it doesn't exceed maxLength
                      setPinCode(numericValue);
                    }
                  }}
                  value={pinCode}
                  required={true}
                />
              </div>

              <div className="mt-4 text-center   ml-16 mr-16 items-center self-center flex flex-row   content-center">
                <button
                  disabled={isLoading}
                  className=" w-full   rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm  hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600  bg-indigo-600">
                  {isLoading ? "Saving..." : "Create"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreatePin;
